import { gsap } from "gsap";
import * as focusTrap from 'focus-trap';

let mm = false;

export default {

  setup() {

    console.log('Navigation is set up');

    const responsiveStickyNav = document.querySelector('nav.responsive-sticky');

    if(responsiveStickyNav) {
     
      const menuBtn = responsiveStickyNav.querySelector("#menuBtn");
      const menuWrap = responsiveStickyNav.querySelector('.menu-wrap');
      const logoButton = responsiveStickyNav.querySelector('#logoButton');
      const navItems = gsap.utils.toArray(".nav-item");
      const closeIcon = responsiveStickyNav.querySelector('.close-icon');
      const menuIcon = responsiveStickyNav.querySelector('.menu-icon');

      var trap = focusTrap.createFocusTrap(responsiveStickyNav, {
        initialFocus: false
      });

      let menuOpen = false;

      mm = gsap.matchMedia();

      mm.add("(max-width: 1699px)", () => {
        const tl = gsap.timeline().reverse();
        tl
        .to(menuIcon, {
          autoAlpha: 0,
          duration: 0.2
        })
        .to(closeIcon, {
          autoAlpha: 1,
          duration: 0.2
        }, "<")
        .from(menuWrap, {
          autoAlpha: 0,
          duration: 0
        })
        .from(menuWrap, {
          yPercent: -100,
          ease: "power2.out",
          duration: 0.7
        })
        .from(navItems, {
          y: -10,
          autoAlpha: 0,
          duration: 0.2,
          stagger: 0.1,
          ease: "power2.out"
        })
        ;
        const toggleMenu = () => {
          if (menuOpen) {

            // See https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/

            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);

            tl.reversed(menuOpen);
            tl.progress(0);
            menuOpen = false;
            menuBtn.setAttribute("aria-expanded", menuOpen);
            trap.deactivate();

          } else {

            document.body.style.top = '-' + window.scrollY + 'px';
            document.body.style.position = 'fixed';

            tl.reversed(menuOpen);
            menuOpen = true;
            menuBtn.setAttribute("aria-expanded", menuOpen);
            trap.activate();
          }
        };

        menuBtn.addEventListener("click", toggleMenu);
        navItems.forEach((item) => {
          item.addEventListener("click", toggleMenu);
        });

        return () => {
          menuBtn.removeEventListener("click", toggleMenu);
          menuOpen = false;
          menuBtn.setAttribute("aria-expanded", menuOpen);
          trap.deactivate();
        };
      });
      
    }

  },
  destroy() {

    document.body.removeAttribute("style");

    if(mm) {
      mm.revert();
      console.log('nav destroy function');
    }
  },
}

